/**
 * MarkerResizer is a simple plugin that allows you to resize
 * markers when they are clicked. This plugin depends on whether
 * markers have an activeIcon and defaultIcon property containing
 * the icon to be used when resizing happens. This was set in the
 * MarkerDrawer plugin.
 *
 * It also listens for when a marker was opened. If the marker has
 * changed (clicked a different one) then it takes care of resizing
 * both the old and the new one.
 * If you want to resize a marker that is not done via clicking,
 * row selection or drawer selection, you can resize by calling
 * BatchGeoGoogleMapsMarker.MarkerResizer.zoomIn(marker) and
 * BatchGeoGoogleMapsMarker.MarkerResizer.zoomOut(marker) respectively.
 */
(function () {
  var MarkerResizer = function () {
    var self = this;

    var init = function () {
      /**
       * Listen for RowSelect changes
       */
      BatchGeoStore.addListener(
        function (state) {
          return state.RowSelect.selection;
        },
        // We can just check if the rows have changed
        function (nextSelectedRows, prevSelectedRows) {
          return !_.isEqual(
            nextSelectedRows.toString(),
            prevSelectedRows.toString(),
          );
        },
        // Row selection has change...
        function (newRows, prevRows) {
          // Restore previous markers to their default size/z index
          if (prevRows.length > 0) {
            prevRows.forEach(function (row) {
              if (self.getMarker(row)) {
                const groupingStatus =
                  BatchGeoStore.getState().BatchGeoOptimalRouteToolbar
                    .distanceChannel;
                if (groupingStatus === 1) {
                  self.MarkerResizer.pend(self.getMarker(row));
                } else if (newRows.indexOf(row) === -1) {
                  self.MarkerResizer.zoomOut(self.getMarker(row));
                  self.getMarker(row).zIndex =
                    window.batchGeoGoogleMapsMarker.getMarkers().length -
                    row +
                    5;
                }
              }
            });
          }

          // Single marker selected, open infowindow
          if (newRows.length === 1) {
            self.MarkerResizer.zoomIn(self.getMarker(newRows[0]));
            self.MarkerInfoWindow.open(self.getMarker(newRows[0]));
          }

          // Multiple rows selected, close any open infowindow.
          if (newRows.length > 1 || newRows.length === 0) {
            newRows.forEach(function (row) {
              self.MarkerResizer.zoomIn(self.getMarker(row));
            });
          }

          // Move marker(s) to front
          if (newRows.length > 0) {
            newRows.forEach(function (row) {
              let marker = self.getMarker(row);
              if (marker)
                marker.zIndex =
                  window.batchGeoGoogleMapsMarker.getMarkers().length + 5;
            });
          }

          if (
            window.per.map_render_type.type === "choropleth" &&
            !window.per.disableChoropleth
          ) {
            window.batchGeoGoogleMapsMarker.MarkerDrawer.renderChoropleth();
          }
        },
      );
    };

    /*
     * Handles zooming in and out of markers when a selection happens.
     * This gets called from the listener above when the selection changes.
     */
    // var handleZoomForMarkersFromDrawing = function (newRows, prevRows) {
    // 	//this is where the previous state becomes handy. Restore previous markers
    // 	//to their default size

    // 	// this seems to take markers from active -> inactive.
    // 	// we should interject and assess if we are in a grouping function
    // 	// if so, we should pend the marker

    // 	// so far the best way to determine if a marker is in the pending state is by
    // 	// checking the opacity parameter on the url for the markersIcon
    // 	if (prevRows.length > 0 && newRows.length > 0) {
    // 		prevRows.forEach(function (row) {
    // 			const marker = self.getMarker(row);
    // 			if (newRows.indexOf(row) === -1) {
    // 				self.MarkerResizer.zoomOut(marker);
    // 			}
    // 		});
    // 	}

    // 	if (newRows.length > 1) {
    // 		newRows.forEach(function (row) {
    // 			self.MarkerResizer.zoomIn(self.getMarker(row));
    // 		});
    // 	}
    // };

    var makeMarkerBigger = function (marker) {
      if (!marker || marker.setIcon == undefined) return;
      marker.setIcon(marker.activeIcon);
    };

    var makeMarkerPending = function (marker) {
      if (!marker || marker.setIcon == undefined) return;
      marker.setIcon(marker.pendingIcon);
    };

    var makeMarkerSmaller = function (marker) {
      if (!marker || marker.setIcon == undefined) return;
      marker.setIcon(marker.defaultIcon);
    };

    // Public API
    self.MarkerResizer = {
      zoomIn: makeMarkerBigger,
      zoomOut: makeMarkerSmaller,
      pend: makeMarkerPending,
    };

    init();
  };

  window.MarkerResizer = MarkerResizer;
})(window);
